/* eslint-disable */
import axios from "axios";
import { toast } from "react-toastify";

export const BASE_URL_GROWTHZILLA = "/growthzilla/remote/public";

export const callApi = async (url, method = "GET", data, headers, params) => {
  const config = {
    method,
    url: BASE_URL_GROWTHZILLA + url,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
    data,
    params,
  };
  return axios(config)
    .then((response) => {
      if (
        response.data?.status === false &&
        response.data?.message === "Please log in to continue."
      ) {
        window.postMessage({ method: "loggedOut" });
      }
      // console.log("response from callapi",response.data)
      return response.data;
    })
    .catch(() => {
      toast.error("Ooops Something went wrong");
    });
};

export const callApiIO =
  process.env.REACT_APP_ENV === "locale"
    ? async (url, method = "GET", data, headers, params) => {
        const PORT = process.env.REACT_APP_LOCAL_SERVER_PORT || 8081;
        const searchParams = new URL(`http://localhost:${PORT}` + url)
          .searchParams;
        const dest = searchParams.get("dest") || params?.dest || "";

        return axios({
          method,
          url: `http://localhost:${PORT}/123456/${dest
            .replace(":BID:", 3)
            .replace(":NID:", 3)
            .replace(":UID:", 1)
            .replace(":SID:", 4)}`,
          withCredentials: false,
          headers: {
            "Content-Type": "application/json",
            ...headers,
          },
          data,
          params,
        })
          .then((response) => {
            // console.log("response from callapiIO",response.data)
            return response.data;
          })
          .catch(() => {
            toast.error("Ooops Something went wrong");
          });
      }
    : callApi;

export const callApiStreaming = async (
  url,
  urlBase,
  sessionToken,
  method = "GET",
  data,
  headers,
  params,
  options = {},
) => {
  const { onRawLine, onStreamEnd, onError, setLoading, abortController } =
    options;

  try {
    const streamUrl = urlBase + url;

    const response = await fetch(streamUrl, {
      method,
      // credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-campaign-chat-token": sessionToken,
        ...headers,
      },
      body: method !== "GET" ? JSON.stringify(data) : undefined,
      signal: abortController?.signal,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    if (response.url.includes("/login") || response.status === 401) {
      window.postMessage({ method: "loggedOut" });
      throw new Error("Please log in to continue.");
    }

    const contentType = response.headers.get("content-type");

    if (contentType && contentType.includes("application/json")) {
      const responseData = await response.json();
      if (responseData.error) {
        toast.error(responseData.error);
        if (setLoading) setLoading(false);
        return;
      }
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();

    const processStream = async () => {
      if (abortController?.signal?.aborted) {
        return;
      }

      try {
        const { value, done } = await reader.read();

        if (done) {
          if (onStreamEnd) onStreamEnd();
          return;
        }

        if (abortController?.signal?.aborted) {
          return;
        }

        const chunk = decoder.decode(value);
        const lines = chunk.split("\n");

        for (const line of lines) {
          if (abortController?.signal?.aborted) {
            break;
          }

          if (line.trim() && onRawLine) {
            onRawLine(line.trim());
          }
        }

        if (!abortController?.signal?.aborted) {
          await processStream();
        }
      } catch (error) {
        if (error.name !== "AbortError") {
          throw error;
        }
      }
    };

    await processStream();
  } catch (error) {
    if (error.name === "AbortError") {
      console.log("Stream cancelled by user");
      if (onStreamEnd) onStreamEnd();
      return;
    } else {
      if (onError) onError(error);
      if (setLoading) setLoading(false);
      return;
    }
  }
};

export const callApiIOStreaming =
  process.env.REACT_APP_ENV === "locale"
    ? async (
        url,
        urlBase,
        sessionToken,
        method = "GET",
        data,
        headers,
        params,
        options = {},
      ) => {
        const { onRawLine, onStreamEnd, onError, setLoading, abortController } =
          options;

        const PORT = process.env.REACT_APP_LOCAL_SERVER_PORT || 8081;

        const streamUrl = `http://localhost:${PORT}${url}`;

        try {
          const response = await fetch(streamUrl, {
            method,
            headers: {
              "Content-Type": "application/json",
              "x-campaign-chat-token": sessionToken,
              ...headers,
            },
            body: method !== "GET" ? JSON.stringify(data) : undefined,
            signal: abortController?.signal,
          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const contentType = response.headers.get("content-type");

          if (contentType && contentType.includes("application/json")) {
            const responseData = await response.json();
            if (responseData.error) {
              toast.error(responseData.error);
              if (setLoading) setLoading(false);
              return;
            }
          }

          const reader = response.body.getReader();
          const decoder = new TextDecoder();

          const processStream = async () => {
            if (abortController?.signal?.aborted) {
              return;
            }

            try {
              const { value, done } = await reader.read();

              if (done) {
                if (onStreamEnd) onStreamEnd();
                return;
              }

              if (abortController?.signal?.aborted) {
                return;
              }

              const chunk = decoder.decode(value);
              const lines = chunk.split("\n");

              for (const line of lines) {
                if (abortController?.signal?.aborted) {
                  break;
                }

                if (line.trim() && onRawLine) {
                  onRawLine(line.trim());
                }
              }

              if (!abortController?.signal?.aborted) {
                await processStream();
              }
            } catch (error) {
              if (error.name !== "AbortError") {
                throw error;
              }
            }
          };

          await processStream();
        } catch (error) {
          if (error.name === "AbortError") {
            console.log("Stream cancelled by user");
            if (onStreamEnd) onStreamEnd();
            return;
          } else {
            if (onError) onError(error);
            if (setLoading) setLoading(false);
            return;
          }
        }
      }
    : callApiStreaming;

export const callApiDam = async (
  url,
  method = "GET",
  data,
  headers,
  params,
) => {
  const config = {
    method,
    url: BASE_URL_GROWTHZILLA + url,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
    data,
    params,
  };
  return axios(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.log("error", { error });
      toast.error("Dam server is currently offline !");
    });
};
